import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersSkillEvaluationStandardSummaryCategoryMutateRequestType,
  ApiManagersSkillEvaluationStandardSummaryCategoryMutateType,
} from "~/domains";

type RequestDataType = {
  body: ApiManagersSkillEvaluationStandardSummaryCategoryMutateRequestType;
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersSkillEvaluationStandardSummaryCategoryMutateType>(
      "/api/managers/skill_evaluation_standard_summary_categories",
      {
        skillEvaluationStandardSummaryCategory: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersSkillEvaluationStandardSummaryCategoriesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersSkillEvaluationStandardSummaryCategoryMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
